module.exports = __webpack_public_path__ + "static/media/9.cda15651.png";